import { createSelector } from 'reselect'
import entryDataSelector from '../entryDataSelector'
import ViewTracking from '../../../entities/ViewTracking'

const viewTrackingSelector = createSelector(
    entryDataSelector,
    (entryData): ViewTracking | null => entryData?.viewTracking || null,
)

export default viewTrackingSelector
